import { render, staticRenderFns } from "./Correct2Manage.vue?vue&type=template&id=0632e3a5&scoped=true&"
import script from "./Correct2Manage.vue?vue&type=script&lang=js&"
export * from "./Correct2Manage.vue?vue&type=script&lang=js&"
import style0 from "./Correct2Manage.vue?vue&type=style&index=0&id=0632e3a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0632e3a5",
  null
  
)

export default component.exports